// client/src/components/influencer/influencerMybizNav.js
// 인플루언서 마이비즈 모바일 내비 공통 매핑 (v4 시안 확정)
// sub 키만으로 소속 탭이 유일하게 정해지므로 URL은 ?sub= 하나만 쓴다 (마케터의 tab 쿼리 불필요).

// sub → 하단 탭바 탭 키
export const TAB_OF = {
  home: 'home',
  projectApply: 'apply',
  projectApplyCheck: 'work',
  projectContract: 'work',
  resultSend: 'work',
  pointList: 'point',
  pointExchange: 'point',
  snsView: 'my',
  snsLink: 'my', // SNS 계정 연동 (Instagram OAuth — FEATURE_IG_SNS_INTEGRATION)
  snsAdd: 'my',
  bank: 'my',
  contract: 'my',
  profile: 'my',
  password: 'my',
  inquiryCheck: 'my',
  inquiryFinish: 'my',
};

// 컨텍스트 칩바: 탭별 하위 항목 (home·apply는 하위 없음 → 칩바 숨김)
export const SUBNAV = {
  work: [
    ['지원 중 (Applied)', 'projectApplyCheck'],
    ['계약하기 (Contracts)', 'projectContract'],
    ['결과물 제출 (Submit)', 'resultSend'],
  ],
  point: [
    ['포인트 내역 (History)', 'pointList'],
    ['환전 신청 (Withdraw)', 'pointExchange'],
  ],
  my: [
    ['SNS·단가 (Rates)', 'snsView'],
    ['SNS 연동 (Connect)', 'snsLink'],
    ['SNS 추가 (Add)', 'snsAdd'],
    ['통장 (Bank)', 'bank'],
    ['프리랜서 계약 (Contract)', 'contract'],
    ['내 정보 (My Info)', 'profile'],
    ['비밀번호 (Password)', 'password'],
    ['진행 문의 (Open)', 'inquiryCheck'],
    ['완료 문의 (Closed)', 'inquiryFinish'],
  ],
};
